import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApacheechartsComponent } from './simple-icons-apacheecharts.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApacheechartsComponent ],
    exports:      [ SimpleIconsApacheechartsComponent ],
    bootstrap:    []
})
export class SimpleIconsApacheechartsModule {}
